/**
 * Pre-generated pool of pseudonymous player usernames for the social-proof
 * Recent Activity feed. Generated once via the canonical username algorithm
 * (see AuthContext.jsx — same adjective/noun/4-digit-number format) and
 * baked in here so the feed has a stable identity pool without paying a
 * runtime generation cost.
 *
 * If you ever rebuild this list, run the same algorithm so display masks
 * (e.g. "S***1234") still preserve the 4-digit suffix convention.
 */
export const USERNAME_POOL = [
  "StealthShark2953",
  "StrongTower6431",
  "LuckyHawk9940",
  "VioletDragon7866",
  "VioletAxe2777",
  "CleverTemple2141",
  "ValiantDragon3588",
  "RadiantFox8801",
  "ValiantHornet3708",
  "ShadowThrone7563",
  "CrimsonHawk5631",
  "FatCastle2415",
  "EmeraldOctopus7628",
  "SavageThunder9678",
  "AgileShrine3250",
  "LegendaryBlade4601",
  "SwiftDragon8201",
  "MightyHammer9357",
  "BravePython3936",
  "FearlessJaguar2999",
  "FatShark9539",
  "ObsidianSun3456",
  "AzurePanther2828",
  "SwiftFortress2916",
  "PureBlizzard7776",
  "SwiftTemple4128",
  "LuckyBlizzard1078",
  "AgileBeetle2087",
  "BoldSpider1295",
  "StrongDragon5718",
  "PlatinumLynx6648",
  "BlazingCrown2901",
  "CleverLightning9790",
  "PlatinumBlizzard5728",
  "PeacefulScorpion4403",
  "SonicCobra5854",
  "MightyLeopard3094",
  "AncientShrine6063",
  "BraveCastle5865",
  "FatViper2689",
  "GentleMeteor3337",
  "BrilliantStorm6966",
  "EpicNebula8361",
  "RoyalLynx7867",
  "SavageLightning1901",
  "RagingShield1026",
  "SilverMantis2588",
  "DaringStar7830",
  "BrilliantViper2458",
  "ValiantStingray1900",
  "BraveLightning5977",
  "FierceSpider6865",
  "FierceCrown7946",
  "AgilePanther2148",
  "PeacefulStar6375",
  "GoldenMoon8633",
  "SlyHawk2175",
  "SparklingFortress1704",
  "SharpPig5042",
  "MysticScorpion7728",
  "SilentRaven3690",
  "SilentLightning4398",
  "TrueFox4995",
  "VioletCheetah6602",
  "ElectricRaven8422",
  "ShiningComet2020",
  "AmberCastle6191",
  "FrozenHornet4906",
  "EmeraldPiranha7234",
  "RagingFortress2917",
  "RagingWasp7750",
  "SavageCastle8630",
  "BrilliantNebula2403",
  "AzureOctopus5136",
  "BrightLightning1304",
  "WiseTornado6990",
  "NobleSpear1502",
  "PeacefulMantis5985",
  "IvoryMeteor2385",
  "AgilePhoenix4501",
  "BrightCobra3692",
  "IvoryFox1015",
  "EmeraldTower9499",
  "GlowingWasp5451",
  "StealthSpear2582",
  "CrimsonFalcon2639",
  "HeroicShield4222",
  "IvoryBear5335",
  "FreeDragon4007",
  "WiseCobra6795",
  "TrueMoon6303",
  "DeadlyFalcon7232",
  "WiseThrone6441",
  "CalmTemple4967",
  "CrimsonLeopard8019",
  "RoyalAxe2433",
  "BrilliantShark1084",
  "BrilliantSpider2639",
  "GentlePanther6078",
  "RoyalCosmos7230",
  "CosmicJaguar5018",
  "NobleArrow7148",
  "BoldThunder3265",
];

/**
 * Mask a generated username for public display in the activity feed.
 * Format: first 3 characters + "***" + 4-digit suffix.
 * Example: "SwiftEagle1234" → "Swi***1234"
 *
 * Shows enough of the name to feel personable and recognisable while
 * hiding the bulk of the identity. The 4-digit suffix preserves
 * per-user uniqueness in the display.
 */
export const maskUsername = (username) => {
  if (typeof username !== "string" || username.length === 0) return "";
  const suffixMatch = username.match(/(\d{4})$/);
  const suffix = suffixMatch ? suffixMatch[1] : "";
  const prefix = username.slice(0, 3);
  return `${prefix}***${suffix}`;
};
